/**
 * The default policy for this sentinel.
 *
 * - `maxAttempts`: 100
 * - `lockoutDuration`: 60 minutes
 */
export const defaultSentinelPolicy = Object.freeze({
    maxAttempts: 100,
    lockoutDuration: 60,
});
